<template>
	<div class="club">
		<div class="club-head">
			<div class="col-1 float-dynamic">
				<font-awesome-icon v-b-toggle.sidebar-menus
								   size="2x"
								   class="mt-2 toggle-menu"
								   icon="bars" />
			</div>
			<div class="col-8 d-none d-md-block float-dynamic">
				<strong class="card-title mt-2 d-block">
					{{ customer.fullName }} عزیز به سامانه رامنیک خوش
					آمدید
				</strong>
			</div>
			<div class="col-2 d-none d-md-block float-left">
				<LiveLogo no_bg tiny />
			</div>
		</div>
		<div class="club-content"
			 :style="{ 'min-height': screenHeight - 90 + 'px' }">
			<div class="container">
				<div class="row">
					<Dashboard v-if="action == 'dashboard'" />
					<Transaction v-if="action == 'transactions'" />
					<SplitAnalytics v-if="action == 'splitAnalytics'" />
					<Card v-if="action == 'cards'" />
					<Request v-if="action == 'requests'" />
					<ResetPassword v-if="action == 'resetPassword'" />
					<Shop v-if="action == 'shop'" />
					<Tickets v-if="action == 'tickets'" />
					<SendTicket v-if="action == 'send-ticket'" />
					<ReplyTicket v-if="action == 'reply-ticket'" />
					<ShowTicket v-if="action == 'show-ticket'" />
					<ShopTransaction :shopId="id"
									 v-if="action == 'shopTransactions'" />
					<ShopTransactionGroup :shopId="id"
										  v-if="action == 'shopTransactionsGroup'" />
					<ShopCustomerPayments :shopId="id"
										  v-if="action == 'shopCustomerPayments'" />
					<ShopSplitAnalytics :shopId="id"
										v-if="action == 'shopSplitAnalytics'" />
					<ShopCreateProduct v-if="action == 'shopCreateProduct'" />
					<ShopProductList :shopId="id"
									 v-if="action == 'shopProductList'" />
				</div>
			</div>
		</div>
		<b-sidebar id="sidebar-menus"
				   v-model="visibleMenu"
				   right
				   no-header
				   backdrop
				   shadow>
			<div class="account">
				<table class="table table-sm text-dark bg-pink mb-4 table-borderless text-center">
					<tr>
						<th class="pt-2 pb-3" colspan="2">
							<div class="col-12 mb-2">
								<font-awesome-icon class="mr-2 ml-2"
												   size="3x"
												   icon="user" />
							</div>
							{{ customer.fullName }}
						</th>
					</tr>
					<tr>
						<th>کد ملی</th>
						<td>{{ customer.nationalCode }}</td>
					</tr>
					<tr class="pb-5">
						<th>شماره موبایل</th>
						<td>{{ customer.mobile }}</td>
					</tr>
				</table>

				<ul class="list-group list-group-flush">
					<li v-for="menu in manus"
						:key="menu.key"
						class="list-group-item bg-light pt-2 pb-2"
						v-bind:class="{
							'font-weight-bold': menu.key == action
						}">
						<router-link class="text-dark float-right d-block text-decoration-none"
									 :to="{ name: 'club', params: { action: menu.key } }">
							{{ $t("view.club.menus." + menu.key) }}
						</router-link>
					</li>
					<li style="height:100px;"></li>
				</ul>
			</div>
		</b-sidebar>
	</div>
</template>
<script>
	import store from "@/store";
	import LiveLogo from "@/components/LiveLogo";
	import Dashboard from "@/views/club/Dashboard";
	import Transaction from "@/views/club/Transaction";
	import Request from "@/views/club/Request";
	import TransactionSplitSum from "@/views/club/TransactionSplitSum";
	import SplitAnalytics from "@/views/club/SplitAnalytics";
	import ShopSplitAnalytics from "@/views/club/ShopSplitAnalytics";
	import ShopCreateProduct from "@/views/club/ShopCreateProduct";
	import ShopProductList from "@/views/club/ShopProductList";
	import Card from "@/views/club/Card";
	import Shop from "@/views/club/Shop";
	import ShopTransaction from "@/views/club/ShopTransaction";
	import ShopTransactionGroup from "@/views/club/ShopTransactionGroup";
	import ShopCustomerPayments from "@/views/club/ShopCustomerPayments";
	import ResetPassword from "@/views/club/ResetPassword";
	import Tickets from "@/views/club/Tickets";
	import SendTicket from "@/views/club/SendTicket";
	import ReplyTicket from "@/views/club/ReplyTicket";
	import ShowTicket from "@/views/club/ShowTicket";
	import utility from "@/plugins/utility";
	//import Mgr from "../oidc/SecurityService";

	export default {
		components: {
			Dashboard,
			LiveLogo,
			Transaction,
			TransactionSplitSum,
			SplitAnalytics,
			Request,
			Card,
			Shop,
			ShopTransaction,
			ShopTransactionGroup,
			ShopCustomerPayments,
			ShopSplitAnalytics,
			ShopCreateProduct,
			ShopProductList,
			ResetPassword,
			Tickets,
			SendTicket,
			ShowTicket,
			ReplyTicket
		},

		data()
		{
			return {
				screenHeight: 0,
				visibleMenu: false,
				action: null,
				//mgr: new Mgr(),
				id: null,
				customer: store.customer,
				manus: [
					{ key: "home" },
					{ key: "dashboard" },
					{ key: "tickets" },
					{ key: "transactions" },
					{ key: "splitAnalytics" },
					{ key: "requests" },
					{ key: "shop" },
					{ key: "cards" },
					{ key: "signout" }
				]
			};
		},

		beforeMount()
		{
			const signout = () =>
			{
				const db = new utility.db();
				store.user = null;
				store.customer = null;
				store.token = null;
				db.delete("__c");
				db.delete("__t");

				//this.mgr.signOut();
				this.$router.push("/auth");
			};

			this.action = this.$route.params.action;
			this.id = this.$route.params.id;
			this.screenHeight = window.outerHeight;

			if (this.action != null && this.action == "signout")
			{
				signout();
			}

			if (this.action != null && this.action == "home")
			{
				this.$router.push("/");
			}

			if (this.action != null && this.action == "marketPlace")
			{
				if (store.customer == null)
				{
					window.location.href = "https://nicard.ir";
				}
				else
				{
					window.location.href = "https://auth.nicard.ir/Manage";
				}
			}

			axios({ url: "/api/App/TokenIsValid" })
				.then(response => { })
				.catch(error =>
				{
					localStorage.clear();
					this.$router.push("/auth");

					//signout();
				});
		}
	};
</script>
<style>
	html,
	body,
	#app {
		background: #f8f8f8;
	}

	.club {
		width: 100%;
		min-height: 100%;
	}

	table {
		font-size: 13px;
	}

	.table > tbody > tr > td,
	.table > tbody > tr > th {
		vertical-align: middle;
		padding: 7px;
	}

	.table-silver {
		background: #f8f8f8;
	}

	.table-mobile {
		border-bottom: #ddd solid 1px;
		padding-top: 20px;
	}

	.btn-sm2 {
		padding: 2px 5px;
		font-size: 13px;
	}

	.club-head {
		top: 0;
		left: 0;
		width: 100%;
		z-index: 100;
		position: fixed;
		padding: 10px;
		background: #fff;
		border-radius: 0 0 0 100px;
		box-shadow: 0 1px 3px 0 rgba(221, 221, 221, 1);
	}

	.club-bg {
		width: 100%;
		height: 400px;
		position: relative;
		background: linear-gradient( to right, #051830 0%, #051830 30%, #2664b1 100% ) !important;
	}

		.club-bg .shape {
			width: 100%;
			position: absolute;
			bottom: 0;
			color: #666;
		}

	.club-content {
		width: 100%;
		min-height: 100%;
		float: left !important;
		display: block;
		margin-top: 100px;
		background: #f8f8f8;
		padding-bottom: 50px;
	}

		.account,
		.club-content .content {
			width: 100%;
			min-height: 100%;
			float: left;
			border-radius: 10px;
		}

			.account ul {
				padding: 0;
			}

			.account img {
				max-width: 130px;
			}

	.club,
	.club-bg,
	.club-content {
		float: left;
	}

	.list-group li {
		cursor: pointer;
	}

		.list-group li a {
			width: 100%;
			height: 100%;
		}

	.toggle-menu {
		cursor: pointer;
	}

		.toggle-menu:active,
		.toggle-menu:hover,
		.toggle-menu:focus {
			outline: 0;
			border: none;
		}
</style>
